/**
 * 收货地址 回显
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 **/
import React from "react";
import {trim,isEmpty,isEmptyObject} from '@utils/utils';
import Lang from '@components/Lang/Lang';
import './address.less'
export default class Address extends React.Component{
    static defaultProps = {
        address:{}, //只展示当前
        on: true, // 展示选中效果
    };
    renderItem(title,item){
        return (<div className={"mt_12"}>
            <div className={"black45"}>{title}</div>
            <div className={"black89"}>{item}</div>
        </div>)
    }
    componentDidMount() {
        if( this.props.onRef)this.props.onRef(this);
    };
    render() {
        const { address, on,canClick} = this.props;
        return (<div className={`addressWrap${on?" addressPickWrap":""}${canClick?" cursor-p":""}`}
                     key={on+"_"+address.id} >
            <div className={"cont black89"}>
                <div className={""}>{Lang({id:"ShouJianRen",default:"收件人"})}</div>
                <p>{address.contactName}</p>
                <p>{address.contactTelCode} {address.contactMobile}</p>
                {this.renderItem(Lang({id:"ShuiWuHaoHuZhaoXinXi",default:"税务号/护照信息"}),address.taxRegistrationNo)}
                {this.renderItem(Lang({id:"ShouJianRenSuoZaiChengShi",default:"收件人所在城市"}),address.cityName)}
                {this.renderItem(Lang({id:"YunShuGongSiZhongDianZhan",default:"运输公司终点站"}),address.terminalName)}
                {this.renderItem(Lang({id:"ChengShiJiaoHuoDiZhi",default:"城市交货地址"}),address.deliveryAddress)}
                {this.renderItem(Lang({id:"BeiZhu",default:"备注"}),address.remark)}
            </div>
        </div>);
    }
}

